export default __webpack_public_path__ + "static/media/310px-190px-square-PMR-Dev-no-border.baea9d1a.jpg";